import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=ae0ef87a"
import script from "./AreaSelect.vue?vue&type=script&lang=js"
export * from "./AreaSelect.vue?vue&type=script&lang=js"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=ae0ef87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports